import { SITE } from '@/shared/config/site';
import type { AuthMode } from '../model/authModalStore';
import { LoginForm } from './LoginForm';
import { SignUpForm } from './SignUpForm';

interface AuthPanelProps {
  mode: AuthMode;
  onModeChange: (mode: AuthMode) => void;
  /** Called after a successful sign-in (e.g. to close the modal). */
  onSuccess?: () => void;
}

const COPY = {
  login: { title: 'Welcome back', subtitle: 'Sign in to comment, react and manage your profile.' },
  signup: {
    title: 'Create your account',
    subtitle: `Join the readers of ${SITE.name} — it’s free.`,
  },
} as const;

/** Mode-switching login/sign-up panel, shared by the auth modal and the /auth page. */
export function AuthPanel({ mode, onModeChange, onSuccess }: AuthPanelProps) {
  const copy = COPY[mode];

  return (
    <div>
      <header className="mb-6">
        <h2 className="font-display text-2xl font-black italic text-foreground">{copy.title}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{copy.subtitle}</p>
      </header>

      {mode === 'login' ? <LoginForm onSuccess={onSuccess} /> : <SignUpForm />}

      <p className="mt-5 text-center text-sm text-muted-foreground">
        {mode === 'login' ? (
          <>
            New here?{' '}
            <button
              type="button"
              onClick={() => onModeChange('signup')}
              className="font-semibold text-amber-600 hover:underline dark:text-amber-400"
            >
              Create an account
            </button>
          </>
        ) : (
          <>
            Already have an account?{' '}
            <button
              type="button"
              onClick={() => onModeChange('login')}
              className="font-semibold text-amber-600 hover:underline dark:text-amber-400"
            >
              Sign in
            </button>
          </>
        )}
      </p>
    </div>
  );
}
